module.exports = __webpack_public_path__ + "img/logo_new.04ac3240.png";